import React from 'react';
import styled from 'styled-components';
import { AutoSizer } from 'react-virtualized';
import { Loader } from '../../Loaders';
import useMinChartHeight from '../utils/useMinChartHeight';
import { ChartMode } from '../types';
import { IStyled } from '../../../styles/types';

interface IProps extends IStyled {
  mode: ChartMode;
}

const Container = styled.div`
  flex: 1;
`;

const ResponsiveChartLoader = ({ mode, className }: IProps) => {
  const minChartHeight = useMinChartHeight(mode);

  return (
    <Container className={className} style={{ minHeight: minChartHeight }}>
      <AutoSizer disableWidth={true}>
        {({ height }) =>
          height > 0 && (
            <div style={{ width: '100%', height }}>
              <Loader />
            </div>
          )
        }
      </AutoSizer>
    </Container>
  );
};

export default ResponsiveChartLoader;
